<template lang="pug">
  div.w.subtitle-1
    div
      | Looks like we have already sent the link to
    div.mb-4
      strong {{ sentTo }}
    div.mb-4
      | Do you wish to resend it?
    v-btn(
      color="blue"
      dark
      @click="$emit('resend')"
    ) Resend It
</template>

<script>
  export default {
    name: 'resend-easy-link-dialog',
    props: {
      sentTo: String,
    },
  }
</script>
